import type { ConfigContextValue } from '@core/context';

import { useContext, useMemo } from 'react';

import { ConfigContext, ProjectContext } from '@core/context';

/**
 * Determines if the app is in preview mode based on environment and user flags.
 * Returns true if both previewEnvironment and superHubPreviewFlag are true and dryRunPreviewFlag is false.
 */
const useIsMigrationPreview = () => {
  const config = useContext(ConfigContext) as ConfigContextValue;
  const { project } = useContext(ProjectContext) || {};

  const previewEnvironment = config?.shMigration.migrationPreview;
  const superHubPreviewFlag = project.flags.superHubPreview;
  const migrationType = project.git?.migrationType;

  const isMigrationPreview = useMemo(() => {
    return Boolean(previewEnvironment && superHubPreviewFlag && migrationType === 'preview');
  }, [previewEnvironment, superHubPreviewFlag, migrationType]);

  return { isMigrationPreview };
};

export default useIsMigrationPreview;
